import { reatomAsync } from "@reatom/async";
import { UserLoginDto } from "definitions/poizon-sso";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { trackAuthError, trackEvent } from "src/util/analytics";

export const loginRequest = reatomAsync(async (_ctx, dto: UserLoginDto) => {
  try {
    const response = await API.authApi.authControllerSignIn(dto);
    // Отслеживаем успешную авторизацию
    trackEvent("login_completed");
    return response;
  } catch (error) {
    // Отслеживаем ошибки авторизации
    trackAuthError("failed", {
      email: dto.email,
      errorMessage: error instanceof Error ? error.message : "Unknown error",
    });
    throw error;
  }
}, "loginRequest").pipe(withIsLoadingAtom());
